<template>
  <div
    v-if="produit"
    :class="[
      jel_getClassObject(content),
      { 'produit-desactive': produitDesactivation && produitDesactivation.indDesactive },
    ]"
    class="cursor-pointer info-produit"
    @click="jel_forcerClickHyperlien(refRedirection)"
  >
    <b-link
      :ref="refRedirection"
      v-bind="jel_getLienBinding(mixinProduitCasino_getLienPageProduit())"
      class="d-none"
    >
      <!-- conserver pour accessibilité -->
      invisible
    </b-link>
    <div
      v-if="isVisible"
      class="d-flex flex-row position-relative align-items-center produit-casino w-100"
    >
      <b-row class="w-100 mx-auto">
        <b-col :cols="jel_isCarteLarge(content) ? 2 : 3" class="px-0 my-auto">
          <div class="disabled-overlay"></div>
          <MediaImageLogo :content="contentMediaImageLogo" class="image-produit" />
        </b-col>
        <b-col
          :cols="jel_isCarteLarge(content) ? 10 : 9"
          class="d-flex flex-row justify-content-between align-items-center w-100 pl-1"
        >
          <b-container class="p-0">
            <b-row>
              <b-col :cols="jel_isCarteLarge(content) ? 9 : 8" class="pr-1">
                <div class="titre-jeu graphik_bold" v-html="mixinProduitCasino_getTitre()" />
                <div v-if="isLotProgressif && !isProduitDesactive" class="d-flex align-items-end">
                  <span v-if="mntProgressif" class="lot-progressif graphik_bold">
                    {{ formatMontantProgressif }}
                  </span>
                  <span v-else class="progressif-multiple graphik_regular">
                    {{ $i18n.tc('messageComponent.progressif', nbProgressif) }}
                  </span>
                  <span
                    v-if="nbProgressif > 1 && (jel_isCarteLarge(content) || !mntProgressif)"
                    class="progressif-multiple progressif-multiple-large"
                    >{{ $i18n.tc('messageComponent.progressif', nbProgressif) }}</span
                  >
                </div>
                <div
                  class="mise-jeu graphik_regular font-weight-normal"
                  v-html="mixinProduitCasino_getMiseMinMax()"
                />
              </b-col>
              <b-col
                :cols="jel_isCarteLarge(content) ? 3 : 4"
                class="d-flex align-items-center px-0"
              >
                <Hyperlien
                  :aria-label="mixinProduitCasino_getTitre(false)"
                  :content="{
                    texte: getTexteBoutonJouer,
                    theme: 'themeClair',
                    type: 'boutonPrimaire',
                    classeCSS: 'd-flex justify-content-end w-100',
                    lien: mixinProduitCasino_getLienPageProduit('mode=lancer'),
                  }"
                />
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </div>
    <div
      v-else
      v-observe-visibility="{
        callback: visibilityChanged,
        once: true,
      }"
      class="chargement"
    >
      <span>{{ mixinProduitCasino_getTitre(false) }}...</span>
    </div>
  </div>
</template>

<script>
import { ObserveVisibility } from 'vue-observe-visibility';

import { mapGetters } from 'vuex';
import { formatMontant } from '@/helpers/StringHelpers';
import mixinProduitCasino from '@/mixins/casino/mixinProduitCasino';

import Hyperlien from '@/components/base/Hyperlien';
import MediaImageLogo from '@/components/media/image/MediaImageLogo';

export default {
  name: 'MediaImageLogoProduitCasinoLarge',
  components: {
    MediaImageLogo,
    Hyperlien,
  },
  directives: {
    ObserveVisibility,
  },
  mixins: [mixinProduitCasino],
  props: {
    content: { type: Object, required: false },
  },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          progressif: 'Lot progressif | Lot progressif | Progressifs multiples',
        },
      },
      en: {
        messageComponent: {
          progressif: 'Progressive Jackpot | Progressive Jackpot | Multiple Jackpots',
        },
      },
    },
  },
  data() {
    return {
      isVisible: false,
      refRedirection: this._uid,
    };
  },
  computed: {
    ...mapGetters({
      getProduitCasinoByUuid: 'produitCasino/getByUuid',
      getStatutProduit: 'produitCasino/getStatutProduit',
      getProgressifByUuid: 'progressif/getByUuid',
      getProgressifCasinoMontant: 'progressif/getProgressifCasinoMontant',
      isProgressifLotProgressif: 'progressif/isLotProgressif',
    }),
    produit() {
      // On peut recevoir un produit complet ou uniquement son UUID
      return this.content.produit ?? this.getProduitCasinoByUuid(this.content.idProduit);
    },
    produitDesactivation() {
      return this.getStatutProduit(this.produit, this.$isMobile());
    },
    isProduitDesactive() {
      return this.produitDesactivation?.indDesactive;
    },
    progressif() {
      return this.getProgressifByUuid(this.produit.idProgressif);
    },
    isLotProgressif() {
      return this.isProgressifLotProgressif(this.progressif);
    },
    mntProgressif() {
      return this.getProgressifCasinoMontant(this.progressif);
    },
    formatMontantProgressif() {
      return formatMontant(this.mntProgressif);
    },
    nbProgressif() {
      return this.produit.listeProgressif?.length ?? 0;
    },
    contentMediaImageLogo() {
      return {
        image: this.produit.image || this.$store.state.produitCasino.imageDefaut,
        image2: this.produit.image2,
        image3: this.produit.image3,
        altImage: this.mixinProduitCasino_getTitre(false),
      };
    },
    getTexteBoutonJouer() {
      return `${this.$t(
        'jouer'
      )} <span class='sr-only'>${this.mixinProduitCasino_getTitre()}</span>`;
    },
  },
  methods: {
    visibilityChanged(isVisible, entry) {
      this.isVisible = isVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
.produit-desactive .disabled-overlay {
  position: absolute;
  width: 100%;
  top: 0;
  background: #ffffff;
  opacity: 0.8;
  height: 100%;
  z-index: 1;
}

.titre-jeu {
  color: $noir-casino;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  ::v-deep sup {
    display: inline-block;
  }
}
.mise-jeu {
  color: $gris-casino;
  margin-top: 2px;
}

.lot-progressif {
  color: $gris-casino;
  margin-top: 2px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.progressif-multiple {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  color: $gris-casino;
}
.progressif-multiple-large {
  margin-left: 5px;
}

.info-produit::after {
  border-bottom: 1px $gris-pale-casino solid;
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  left: auto;
}

.liste-1-colonne::after {
  width: 78%;
}

.format-5x7,
.format-5x6 {
  .info-produit::after {
    width: 75%;
  }
}

.format-4x3 {
  .info-produit::after {
    width: 82%;
  }
}
::v-deep .btn-primaire {
  font-family: graphik_bold;
  text-transform: uppercase;
}
</style>
